module.exports = __webpack_public_path__ + "media/newstyle/images/chevron-right-bd901257c1e2d4857e6726cb2f8158d9.svg";